export default "__VITE_ASSET__QCzxZxbe__"